{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "您的反馈和建议将帮助我们改进产品和服务。",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "如果您有技术或支持问题，或需要立即协助，请按照您的服务协议联系您的 Laserfiche 管理员或解决方案提供商。",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "发现您喜欢或不喜欢的内容？请告诉我们。",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "您有新功能或改进的想法吗？我们期待您的反馈。",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "请勿在反馈中包含任何机密或个人信息",
  "TELL_US_ABOUT_EXPERIENCE": "告诉我们您的体验",
  "TELL_US_ABOUT_IDEA": "告诉我们您的想法",
  "I_HAVE_FEEDBACK": "我有反馈",
  "I_HAVE_SUGGESTION": "我有一个建议",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "您可以就此反馈联系我",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "如果您想加入我们的客户小组，",
  "PLEASE_CLICK_HERE": "请点击这里。",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "图片超过最大文件大小 {0}。",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "图片已损坏或格式无法识别。",
  "ACCEPTED_FORMATS_ARE_0": "接受的格式为：{0}。",
  "IMAGE_NOT_ATTACHED": "未附加图片。",
  "ATTACH_IMAGE": "附加图片",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "请仅附加一张图片。",
  "TAGS": "标签",
  "ADD_TAGS": "添加标签",
  "ADD_MORE_TAGS": "添加更多标签",
  "NO_TAGS_AVAILABLE": "没有可用的标签"
}
